import React from 'react'
import { Row, Col, Input, Button, Checkbox, Form, Empty, Table } from 'antd'
import { InfoCircleOutlined, CheckCircleOutlined, DownloadOutlined } from '@ant-design/icons'
import { withApollo } from 'react-apollo'
import moment from 'moment'
import _ from 'lodash'

import CertGenLogo from '../../assets/We_Learn_Banner.png'
import SadLogo from '../../assets/img/sad.png'
import { savePdf, savePdfIos } from './components/pdfSaver'
import PDFGenerator from './components/pdfGenerator'

import {
    GET_TOPICS_BY_USER_EMAIL
} from './qql'
import {
    CapitalizeEveryFirstLetter,
    joinByUnderscore,
    getFirstWord 
} from '../../functions'

import './DownloadPage.scss'

class DownloadPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            current_user_topics: null,
            current_topic_selected: [],
            downloading: false,
            downloaded: []
        }

        this.genCertFormRef = React.createRef()
    }

    getUserTopicsByEmail = (variables) => {
        const { client } = this.props
        
        client.query({
            query: GET_TOPICS_BY_USER_EMAIL,
            variables
        }).then(res => {
            const { getUserTopicsByUserEmail } = res.data
            this.setState({
                current_user_topics: getUserTopicsByUserEmail,
                current_topic_selected: [],
                downloaded: []
            })
        })
    }

    validateFullname = (rule, value, callback) => {
        if(value &&  value.trim() === '') {
            return callback("Please enter your fullname")
        }
    
        callback()
    }

    generateCertificateForm = () => {
        return (
            <React.Fragment>
                <div className="generate-cert__container">
                    <Form 
                        layout="vertical"
                        hideRequiredMark={true}
                        ref={this.genCertFormRef}
                        onFinish={e => {
                            this.getUserTopicsByEmail({ fullname: e.fullname, email: e.email_address })
                        }}
                        onFinishFailed={e => {
                        }}
                    >
                        <Form.Item
                            label={<div className="form__label">Full Name</div>}
                            name="fullname"
                            rules={[{ required: true, message: 'Please enter your full name' }, { validator: this.validateFullname }]}
                        >
                            <Input
                                placeholder="Input your full name here"
                            />
                        </Form.Item>
                        <Form.Item
                            label={<div className="form__label">Email Address</div>}
                            name="email_address"
                            rules={[
                                { required: true, message: 'Please enter your email address' }, 
                                { type: 'email' , message: 'Please enter a valid Email Address' }
                            ]}
                        >
                            <Input
                                placeholder="Input your email address here (i.e. sample@gmail.com)"
                            />
                        </Form.Item>
                        <Form.Item>
                            <div className="generate-cert__button-div">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="generate-cert__button"
                                >
                                    Generate
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </React.Fragment>
        )
    }

    clickedTopicItem = (uid) => {
        const current_selected = this.state.current_topic_selected

        current_selected.push(uid)

        this.setState({
            current_topic_selected: current_selected
        })
    }

    unclickedTopicItem = (uid) => {
        const { current_topic_selected } = this.state
        const current_selected = []

        current_topic_selected.map(selected => {
            if(selected !== uid) {
                current_selected.push(selected)
            }
        })

        this.setState({
            current_topic_selected: current_selected
        })
    }

    checkIfChecked = (uid) => {
        const { current_topic_selected } = this.state
        var checked = false

        current_topic_selected.map(topic_uid => {
            if(topic_uid === uid) {
                checked = true
            }
        })

        return checked
    }

    checkAll = () => {
        const { current_user_topics } = this.state
        const selected = []

        current_user_topics.map(user_topic => {
            if(!this.checkIfDownloaded(user_topic.uid)) {
                selected.push(user_topic.uid)
            }   
        })

        this.setState({
            current_topic_selected: selected
        })
    }

    uncheckAll = () => {
        this.setState({
            current_topic_selected: []
        })
    }

    onDowloadCerts = () => {
        const { current_topic_selected, current_user_topics } = this.state
        const selected_data = []

        this.setState({
            downloading: true
        })

        current_user_topics.map(user_topic => {
            if(_.includes(current_topic_selected, user_topic.uid)) {
                selected_data.push(user_topic)
            }
        })

        const downloadCerts = async (array) => {
            for (const item of array) {
                await savePdf(PDFGenerator({
                    name: item.user.username, 
                    topic: item.topic.name,
                    date_attended: moment(item.date_attended).format(`Do of MMMM, YYYY`)
                }), `${getFirstWord(item.topic.name)}_${moment().format('MMDDYY')}.pdf`)

                this.downloadedPusher(item.uid)
            }
        }

        downloadCerts(selected_data)
    
        this.setState({
            downloading: false
        })
    }

    onDowloadSingleCert = async (topic) => {

        await savePdfIos(PDFGenerator({
            name: topic.user.profile.fullname, 
            topic: topic.topic.name,
            date_attended: moment(topic.date_attended).format(`Do of MMMM, YYYY`)
        }), `${getFirstWord(topic.topic.name)}_${moment().format('MMDDYY')}.pdf`)

        console.log('Downloaded single cert')
        this.downloadedPusher(topic.uid)
    }

    downloadedPusher = (uid) => {
        const downloaded = this.state.downloaded
        downloaded.push(uid)
        this.setState({
            downloaded
        })
        this.unclickedTopicItem(uid)
    }

    checkIfDownloaded = (uid) => {
        return _.includes(this.state.downloaded, uid)
    }

    certListSetter = () => {
        const { current_user_topics, current_topic_selected } = this.state

        return (
            <React.Fragment>
                <div className="cert-list__div-container">
                    <div>
                        <div className="width--10 display--inline-block cert-list--header bordered-right--white">
                            <Checkbox
                                checked={current_user_topics && current_user_topics.length > 0? current_topic_selected.length === current_user_topics.length : false}
                                disabled={current_user_topics === null || current_user_topics.length === 0}
                                onClick={e => {
                                    if(current_topic_selected.length !== current_user_topics.length){
                                        this.checkAll()
                                    } else {
                                        this.uncheckAll()
                                    }
                                }}
                            />
                        </div>
                        <div className="width--45 display--inline-block cert-list--header bordered-right--white">
                            Certificate
                        </div>
                        <div className="width--45 display--inline-block cert-list--header">
                            Topic
                        </div>
                    </div>
                    <div className="cert-list__table-wrapper">
                        <table className="cert-list__table">
                            <theader>

                            </theader>
                            <tbody className="cert-list__table--body">
                                {current_user_topics?
                                current_user_topics.length > 0?
                                current_user_topics.map(user_topic => {
                                    const { topic, user } = user_topic

                                    return (
                                        <tr className="cert-list__table-row">
                                            <td className="width--10 table--data centered bordered-right--gray">
                                                {this.checkIfDownloaded(user_topic.uid)?
                                                <CheckCircleOutlined className="downloaded--indicator"/>
                                                : 
                                                <Checkbox 
                                                    onClick={e => { 
                                                        if(this.checkIfChecked(user_topic.uid)) {
                                                            this.unclickedTopicItem(user_topic.uid)
                                                        } else {
                                                            this.clickedTopicItem(user_topic.uid)
                                                        }  
                                                    }}
                                                    checked={this.checkIfChecked(user_topic.uid)}
                                                />
                                                }
                                            </td>
                                            <td className="width--45 table--data bordered-right--gray">{`${getFirstWord(topic.name)}_${moment().format('MMDDYY')}.pdf`}</td>
                                            <td className="width--45 table--data">{topic.name}</td>
                                        </tr>
                                    )
                                })
                                : null
                                : null}
                            </tbody>
                        </table>
                    </div>
                    {current_user_topics?
                    current_user_topics.length === 0?
                    <div className="cert-list__no-certificates-found">
                        <Empty 
                            description={<div className="cert-list__no-certificates-found--label">No Certificate Found</div>}
                            image={SadLogo}
                        />
                    </div>
                    : null
                    : null}
                    {current_user_topics === null?
                        <div className="cert-list__no-data">
                            <Empty />
                        </div>
                    : null}
                </div>
            </React.Fragment>
        )
    }

    IosCertListSetter = () => {
        const { current_user_topics, current_topic_selected, current_selected } = this.state
    
        console.log('current_user_topics: ', current_user_topics)

        return (
            <React.Fragment>
                <div className="ios-cert-list__container">
                    <ul className="ios-cert-list__ul">
                        {current_user_topics? current_user_topics.length > 0? current_user_topics.map(topic => {
                            return (
                                <li className="ios-cert-list__li">
                                    <span className="ios-cert-list__topic-name">{topic.topic.name}</span>
                                    {this.checkIfDownloaded(topic.uid)?
                                        <span className="ios-cert-list__download-button-span">
                                            <CheckCircleOutlined className="downloaded--indicator"/>
                                        </span>
                                    : <span className="ios-cert-list__download-button-span">
                                        <Button 
                                            type="primary" 
                                            shape="round" 
                                            icon={<DownloadOutlined />} 
                                            size='small'
                                            onClick={e => {
                                                this.onDowloadSingleCert(topic)
                                            }}
                                        />
                                    </span>}
                                </li>
                            )
                        }) 
                        :
                        <div className="cert-list__no-certificates-found">
                            <Empty 
                                description={<div className="cert-list__no-certificates-found--label">No Certificate Found</div>}
                                image={SadLogo}
                            />
                        </div>
                        : 
                        <div className="cert-list__no-data">
                            <Empty />
                        </div>
                        }
                    </ul>
                </div>
            </React.Fragment>
        )
    }

    render() {
        const { current_user_topics } = this.state
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // const iOS = true

        return (
            <div className="download-page__container">
                <div className="download-page__logo-div">
                    <img 
                        src={CertGenLogo}
                        alt="cert-gen-logo"
                        className="download-page__logo"
                    />
                </div>
                <div className="download-page__description-container">
                    <Row>
                        <Col 
                            xl={{span: 20, offset: 2}}
                            lg={{span: 20, offset: 2}}
                            md={{span: 20, offset: 2}}
                            sm={{span: 22, offset: 1}}
                            xs={{span: 22, offset: 1}}
                        >
                            <div className="download-page__description-div">
                                <p>
                                If you have watched and shared Vibal’s Facebook Live Learning Sessions or 
                                registered in our YouTube Webinar Series, you may search and download your certificates here.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="download-page__cert-gen__container">
                    <Row>
                        <Col
                            xl={{span: 6, offset: 2}}
                            lg={{span: 6, offset: 2}}
                            md={{span: 6, offset: 2}}
                            sm={{span: 22, offset: 1}}
                            xs={{span: 22, offset: 1}}
                        >
                            <div className="download-page__cert-gen__credentials-div">
                                {/* <div className="download-page__cert-gen__credentials--heading">
                                    <InfoCircleOutlined style={{ marginRight: '5px' }}/>Generate your certificates here.
                                </div> */}
                                {this.generateCertificateForm()}
                            </div>
                        </Col>
                        <Col
                            xl={{span: 10, offset: 4}}
                            lg={{span: 10, offset: 4}}
                            md={{span: 10, offset: 4}}
                            sm={{span: 22, offset: 1}}
                            xs={{span: 22, offset: 1}}
                        >
                            <div className="download-page__cert-gen__cert-list-div">
                                <div className="download-page__cert-gen__cert-list--label">
                                    Your Certificates
                                </div>
                                <div className="download-page__cert-gen__cert-list--container">
                                    {iOS? this.IosCertListSetter() : this.certListSetter()}
                                </div>
                                {!iOS? <div className="download-page__cert-gen__cert-list--button-container">
                                    <Button 
                                        type="primary" 
                                        className="download-page__cert-gen__cert-list--button"
                                        disabled={this.state.current_topic_selected.length === 0}
                                        onClick={e => {
                                            if(!this.state.downloading) {
                                                this.onDowloadCerts()
                                            }
                                        }}
                                    >
                                        {this.state.downloading? 'Downloading' : 'Download Certificate(s)'}
                                    </Button>
                                </div> : null}
                                {current_user_topics?
                                <div className="missing-cert__google-form-link">
                                    <p>If you can’t find your certificates, please fill out any of the forms below.</p>
                                    <div className="missing-cert__google-form-link__div">
                                        <span className="missing-cert__google-form-link__span"><a href="https://forms.gle/7TJ8QMSA2onHBxyD8" target="_blank">link 1</a></span>
                                        <span className="missing-cert__google-form-link__span"><a href="https://forms.gle/PSDgXFR8Z21P5Wg69" target="_blank">link 2</a></span>
                                        <span className="missing-cert__google-form-link__span"><a href="https://forms.gle/Xs7etjkyd5KaYyRGA" target="_blank">link 3</a></span>
                                        <span className="missing-cert__google-form-link__span"><a href="https://forms.gle/Mke3nLnGvAcwGQaM7" target="_blank">link 4</a></span>
                                        <span className="missing-cert__google-form-link__span"><a href="https://forms.gle/Yg7ATogNYJRbM8me6" target="_blank">link 5</a></span>
                                    </div>
                                </div>
                                :null}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default withApollo(DownloadPage)